export { default as MyGarageEducationContentDetails } from '../MyGarage2.0/components/MyGarageEducationContentDetails'
